import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { IsRequired } from 'submodules/nerit-framework-utils/validators'
import { IsOptional } from 'class-validator'
import { IDateRangeFilter } from 'submodules/nerit-framework-ui/common/components/form-fields/date-range-picker/inner/IDateRangeFilter'

export class WaterQualityChartFiltersFormModel extends FormModel {

    @IsRequired()
    locationCodes: number[]

    @IsOptional()
    dateRange?: IDateRangeFilter

    constructor(initialData?: Partial<WaterQualityChartFiltersFormModel>) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
